import { render, staticRenderFns } from "./MemberEmail.vue?vue&type=template&id=98dcb4be&"
import script from "./MemberEmail.vue?vue&type=script&lang=js&"
export * from "./MemberEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports